import React from 'react'
import {
  Modal,
  ModalBody,
  ModalHeader,
} from 'reactstrap'


class ShowImageModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      img_base64: '',
    }
  }

  componentDidUpdate(props_old) {
    if (!props_old.show && this.props.show) {
      this._fetchData()
    }
  }

  _fetchData = () => this.setState({ img_base64: this.props.img_base64 })

  _handleClose = () => this.props.onClose()

  render() {
    return (
      <Modal size="lg" centered isOpen={this.props.show} toggle={this._handleClose}>
        <ModalHeader toggle={this._handleClose}>รายละเอียดรูป</ModalHeader>
        <ModalBody className='text-center'>
          <img src={this.state.img_base64} alt="detail-image" />
        </ModalBody>
      </Modal>
    )
  }
}

export default ShowImageModal